import React from 'react'
import { ViewNavigationUtil } from '@utils/viewNavigationUtil'
import { RedirectLoadingSkeleton } from '@features/insurance-form-redirect/components/RedirectLoadingSkeleton'
import { useInsuranceFormRedirect } from '@features/insurance-form-redirect/hooks/useInsuranceFormRedirect'

// redirect for CA and VD flows
export const InsuranceFormRedirect: React.FC = () => {
  const { isLoading } = useInsuranceFormRedirect()

  if (isLoading) {
    const { showSteps } = ViewNavigationUtil.getStepConfig()
    return <RedirectLoadingSkeleton showProgress={showSteps} />
  }

  return null
}
